import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

const FoodContext = createContext();

export const useFood = () => useContext(FoodContext);

export const FoodProvider = ({ children }) => {
  const [foods, setFoods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('All');

  useEffect(() => {
    fetchFoods(); 
  }, []);

  const fetchFoods = async () => {
    setLoading(true);
    try {
      const letters = ['a', 'b', 'c', 'e', 'f', 'g', 'k', 'm', 'p', 's', 'y']; 
      const requests = letters.map(char => axios.get(`https://www.themealdb.com/api/json/v1/1/search.php?f=${char}`));
      
      const responses = await Promise.all(requests);
      
      let allMeals = [];
      responses.forEach(res => {
          if(res.data.meals) {
              allMeals = [...allMeals, ...res.data.meals];
          }
      });

      const uniqueMeals = Array.from(new Set(allMeals.map(a => a.idMeal)))
        .map(id => allMeals.find(a => a.idMeal === id));

      setFoods(uniqueMeals);
      setError(null);
    } catch (err) {
      setError('Failed to fetch data');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getFoodById = async (id) => {
    try {
      const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/lookup.php?i=${id}`);
      return response.data.meals ? response.data.meals[0] : null;
    } catch (err) {
      console.error("Error fetching detail", err);
      return null;
    }
  };

  const filteredFoods = React.useMemo(() => {
    return foods.filter((food) => {
      const matchesCategory = categoryFilter === 'All' || food.strCategory === categoryFilter;
      const matchesSearch = food.strMeal.toLowerCase().includes(searchQuery.toLowerCase());
      return matchesCategory && matchesSearch;
    });
  }, [foods, categoryFilter, searchQuery]);

  const categories = ['All', ...new Set(foods.map(f => f.strCategory))];

  return (
    <FoodContext.Provider value={{
      foods: filteredFoods,
      allFoods: foods,
      loading,
      error,
      searchQuery,
      setSearchQuery,
      categoryFilter,
      setCategoryFilter,
      categories,
      fetchFoods, 
      getFoodById
    }}>
      {children}
    </FoodContext.Provider>
  );
};
